/* eslint-disable react/no-array-index-key */
import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function TransactionHistorySkeleton() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ p: 2 }}>
      {/* Title and Refresh Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="h5">
          <Skeleton width={160} />
        </Typography>
        <Skeleton variant="rectangular" width={80} height={32} />
      </Box>

      {/* Status Counters */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[...Array(4)].map((_, i) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={i}>
            <Card sx={{ borderRadius: 2 }}>
              <CardContent>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton width="60%" height={20} sx={{ mt: 1 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Transactions */}
      <Stack spacing={2}>
        {[...Array(3)].map((_, i) => (
          <Card
            key={i}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 2,
              bgcolor: 'background.paper',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: isMobile ? 'column' : 'row',
              }}
            >
              <Skeleton width={80} height={24} />
              <Skeleton width={100} height={20} sx={{ mt: isMobile ? 1 : 0 }} />
            </Box>

            <Skeleton width="80%" height={28} sx={{ mt: 2 }} />

            <Stack spacing={1} sx={{ mt: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width="25%" height={20} />
                <Skeleton width="40%" height={20} />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width="25%" height={20} />
                <Skeleton width="40%" height={20} />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width="25%" height={20} />
                <Skeleton width="40%" height={20} />
              </Box>
            </Stack>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
